// extracted by mini-css-extract-plugin
var _1 = "ScheduleLabHyperlink__main--n0YrM";
export { _1 as "main" }
